import { FC, useState } from 'react'

import { SetUserProfileRoute } from '@/components/entities/user/hooks/useUserProfileRoute'

import UserContactsFilter from './UserContactsFilter'
import UserContactsList from './UserContactsList'

type Props = {
  setUserProfileRoute: SetUserProfileRoute
}

const UserContactsScreen: FC<Props> = ({ setUserProfileRoute }) => {
  const [page, setPage] = useState(1)

  const onFilterChange = () => {
    setPage(1)
  }

  return (
    <>
      <UserContactsFilter
        className="!-mr-40 !mt-16 mb-20 !pr-40 lg:!-mr-24 lg:mt-0 lg:!pr-24 sm:!-mr-16 sm:mb-12 sm:!pr-16"
        onFilterChange={onFilterChange}
      />
      <UserContactsList setUserProfileRoute={setUserProfileRoute} page={page} />
    </>
  )
}

export default UserContactsScreen
